import { DataNotFoundImage, DataNotFoundNewImage, InfoIcon } from 'assets'
import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { useSelector } from 'react-redux'
import { getEmotionFColor, getEmotionSColor, getEmotionSvgIcon } from 'utils/getEmotionIcon'

function EmotionsScore() {
   const settingData = useSelector((state) => state.settings)
   const { loading, channelDetails } = settingData
   const [notFoundChart, setNotFoundChart] = useState(false)

   useEffect(() => {
      if (
         channelDetails?.positive_percentage_channel === 0 &&
         channelDetails?.neutral_percentage_channel === 0 &&
         channelDetails?.negative_percentage_channel === 0
      ) {
         setNotFoundChart(true)
      } else {
         setNotFoundChart(false)
      }
      return () => {}
   }, [channelDetails])

   return (
      <div className="emotion-score-image">
         <div className="card">
            <div className="emotion-score-section">
               <div className="d-flex justify-content-between align-items-center">
                  <p className="at-text-dark at-font-20">Sentiment Breakdown</p>
                  <InfoIcon />
               </div>
               {/* <p className="at-text-light mt-2 at-font-14">Last updated 2 min ago</p> */}
               {notFoundChart ? (
                  <div className="not-found-section">
                     <img
                        src={DataNotFoundNewImage}
                        alt="DataNotFoundImageF"
                        className="not-found-image"
                     />
                     <p>This YouTube Channel is Now Connected to Atenya!</p>
                     <small className="small-desc-not-found at-text-light">
                        To get started, head over to the Videos tab (upper left corner) and analyze
                        your first video. Once you’ve analyzed a video, the data here will
                        automatically populate and provide insights about your channel. As you
                        continue to analyze more videos, this dashboard will reflect the latest
                        insights across your channel.
                     </small>
                  </div>
               ) : (
                  <div className="row mt-4">
                     <div className="col-12 col-sm-4 col-lg-4 mobile-chart-legend">
                        <div className="chart-legend">
                           <div className="chart-details">
                              <h3 className="at-text-dark score-title">
                                 {channelDetails?.positive_percentage_channel}%
                              </h3>
                              <small>
                                 {/* <span className="improved-text">+2.4%</span> */}
                                 <span className="ms-2 at-text-dark">
                                    {channelDetails?.positive_comments_count}
                                 </span>
                              </small>
                           </div>
                           <div className="legend-icon-section">
                              <div className="legend-dot positiv"></div>
                              <p className="at-text-dark">Positive</p>
                           </div>
                        </div>
                        <div className="chart-legend mt-3">
                           <div className="chart-details">
                              <h3 className="at-text-dark score-title">
                                 {channelDetails?.neutral_percentage_channel}%
                              </h3>
                              <small>
                                 {/* <span className="improved-text">+2.4%</span> */}
                                 <span className="ms-2 at-text-dark">
                                    {channelDetails?.neutral_comments_count}
                                 </span>
                              </small>
                           </div>
                           <div className="legend-icon-section">
                              <div className="legend-dot neutral"></div>
                              <p className="at-text-dark">Neutral</p>
                           </div>
                        </div>
                        <div className="chart-legend mt-3">
                           <div className="chart-details">
                              <h3 className="at-text-dark score-title">
                                 {channelDetails?.negative_percentage_channel}%
                              </h3>
                              <small>
                                 {/* <span className="improved-text">+2.4%</span> */}
                                 <span className="ms-2 at-text-dark">
                                    {channelDetails?.negative_comments_count}
                                 </span>
                              </small>
                           </div>
                           <div className="legend-icon-section">
                              <div className="legend-dot negative"></div>
                              <p className="at-text-dark">Negative</p>
                           </div>
                        </div>
                     </div>
                     <div className="col-12 col-sm-8 col-lg-8 pie-chart">
                        {channelDetails?.channel_id && <PolarAreaChart />}
                     </div>
                  </div>
               )}
            </div>
         </div>
      </div>
   )
}

export default EmotionsScore

const PolarAreaChart = () => {
   const settingData = useSelector((state) => state.settings)
   const { loading, channelDetails } = settingData

   const [options, setOptions] = useState(null)
   const [series, setSeries] = useState(null)

   useEffect(() => {
      if (channelDetails) {
         setSeries([
            channelDetails?.positive_percentage_channel,
            channelDetails?.neutral_percentage_channel,
            channelDetails?.negative_percentage_channel
         ])
      } else {
         setSeries(null)
      }
      return () => {}
   }, [channelDetails])

   useEffect(() => {
      setOptions({
         chart: {
            width: 380,
            type: 'donut',
            dropShadow: {
               enabled: true,
               top: 10,
               left: 0,
               blur: 5,
               color: '#000',
               opacity: 0.1
            }
         },
         dataLabels: {
            enabled: false
         },
         labels: ['Positive', 'Neutral', 'Negative'],
         fill: {
            type: 'gradient',
            // colors: ['#02fd49', '#8f01ff', '#ff951b']
            // colors: ['#27d089', '#286bff', '#f6005a']
            colors: ['#51f430', '#426cf5', '#f5310f']
            // colors: ['#27d089', '#286BFF', '#FF4433']
         },
         stroke: {
            width: 0
         },

         yaxis: {
            show: false
         },

         xaxis: {
            show: false
         },

         legend: {
            show: false
         },
         tooltip: {
            enabled: true,
            custom: function ({ series, seriesIndex, w }) {
               const label = w.globals.labels[seriesIndex]
               const value = series[seriesIndex]
               let PositiveArray = channelDetails?.top_positive_comments || []
               let NagativeArray = channelDetails?.top_negative_comments || []
               const showArr =
                  seriesIndex === 0 ? PositiveArray : seriesIndex === 2 ? NagativeArray : []
               if (seriesIndex === 1) {
                  return null
               } else {
                  return generateTooltipHTML(
                     label,
                     value,
                     showArr,
                     seriesIndex === 0 ? 'positive' : 'negative'
                  )
               }
            },
            fixed: {
               // enabled: true
            }
         }
      })
      return () => {}
   }, [channelDetails])

   return (
      <div>
         <div id="chart">
            {options && series && (
               <ReactApexChart options={options} series={series} type="donut" height={250} />
            )}
         </div>
         <svg
            width="200"
            height="200"
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
            style={{ position: 'absolute' }}>
            <defs>
               {/* Positive Gradient */}
               <linearGradient id="gradientPositive" x1="50%" y1="0%" x2="50%" y2="100%">
                  <stop offset="0%" style={{ stopColor: '#00FF47', stopOpacity: 1 }} />
                  <stop offset="100%" style={{ stopColor: '#19B978', stopOpacity: 1 }} />
               </linearGradient>
               {/* Neutral Gradient */}
               <linearGradient id="gradientNeutral" x1="50%" y1="0%" x2="50%" y2="100%">
                  <stop offset="0%" style={{ stopColor: '#3D6DC8', stopOpacity: 1 }} />
                  <stop offset="100%" style={{ stopColor: '#0066FF', stopOpacity: 1 }} />
               </linearGradient>
               {/* Negative Gradient */}
               <linearGradient id="gradientNegative" x1="50%" y1="0%" x2="50%" y2="100%">
                  <stop offset="0%" style={{ stopColor: '#FF5136', stopOpacity: 1 }} />
                  <stop offset="100%" style={{ stopColor: '#FFD600', stopOpacity: 1 }} />
               </linearGradient>
            </defs>
         </svg>
         <div id="html-dist"></div>
      </div>
   )
}

const generateTooltipHTML = (label, value, showArr, type) => {
   let itemsHTML = ''
   // Loop through the array and generate HTML for each item
   showArr.forEach((item) => {
      itemsHTML += `
         <div class="tooltip-section">
            <div class="progress" style="background-color: #FFFFFF14; border-radius: 32px;">
               <div
                  class="progress-bar"
                  role="progressbar"
                  style="border-radius: 32px; width: ${
                     item.per
                  }%;  background: linear-gradient(61.59deg, ${getEmotionSColor(
         item?.text,
         type
      )} 0%, ${getEmotionFColor(item?.text, type)} 99.45%);
                  "
                  aria-valuenow="${item.per}"
                  aria-valuemin="0"
                  aria-valuemax="100">
               </div>
            </div>
            <div class="d-flex align-items-center justify-content-between mt-1">
               <div class="d-flex align-items-center gap-2">
                  <span class="emotion-chart-icon"> ${getEmotionSvgIcon(item?.text, type)}</span>
                  <span class="text-capitalize">${item.text}</span>
               </div>
               <span>${item.count}</span>
            </div>
         </div>
      `
   })
   // Return the full tooltip HTML with the items from showArr
   return `
      <div class="chart-tooltip">      
         <p class="chart-tooltip-title">Top ${type} Emotion</p>
         ${itemsHTML} <!-- Insert the dynamically generated items -->
      </div>
   `
}

const EmotionsProgressBar = (props) => {
   const { value, lable } = props
   return (
      <div className="emotion-section mt-3">
         <div className="emotion-details">
            <div className="emotion-circle"></div>
            <span>{lable}</span>
         </div>
         <div className="emottion-progress">
            <div className="emottion-progress-bar">
               <ProgressBar now={value} />
            </div>
            <span>{value}%</span>
         </div>
      </div>
   )
}
